/* Inline header search: opens the predictive results panel under the field while typing. */
if (!customElements.get('sv-search-dropdown')) {
  customElements.define(
    'sv-search-dropdown',
    class SvSearchDropdown extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        this.panel = this.querySelector('[data-search-panel]');
        this.reset = this.querySelector('.sv-isearch__reset');
        if (!this.input || !this.panel) return;

        this.controller = new AbortController();
        const { signal } = this.controller;

        this.input.addEventListener('input', () => this.sync(), { signal });
        this.input.addEventListener('focus', () => this.sync(), { signal });
        this.input.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'Escape') {
              this.close();
              this.input.blur();
            }
          },
          { signal }
        );
        this.reset?.addEventListener('click', () => this.close(), { signal });
        document.addEventListener(
          'pointerdown',
          (event) => {
            if (!this.contains(/** @type {Node} */ (event.target))) this.close();
          },
          { signal }
        );
        this.addEventListener(
          'focusout',
          (event) => {
            const next = /** @type {Node | null} */ (event.relatedTarget);
            if (next && !this.contains(next)) this.close();
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      sync() {
        if (this.input.value.trim().length > 0) {
          this.open();
        } else {
          this.close();
        }
      }

      open() {
        this.panel.hidden = false;
        this.classList.add('is-open');
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.panel.hidden = true;
        this.classList.remove('is-open');
        this.input.setAttribute('aria-expanded', 'false');
      }
    }
  );
}
